export const shrinkImageDimensions = (
  [width, height]: [number, number],
  [maxWidth, maxHeight]: [number, number],
) => {
  const scale = Math.min(maxWidth / width, maxHeight / height);
  return [width * scale, height * scale] as const;
};

export const repeatImage = (
  image: HTMLImageElement,
  xRepeats: number,
  yRepeats: number,
) => {
  const canvas = document.createElement('canvas');
  canvas.width = image.width * xRepeats;
  canvas.height = image.height * yRepeats;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not get canvas context');

  for (let x = 0; x < xRepeats; x++) {
    for (let y = 0; y < yRepeats; y++) {
      ctx.drawImage(image, x * image.width, y * image.height);
    }
  }

  const result = new Image();
  result.src = canvas.toDataURL('image/png');
  return result;
};

export const repeatAndScaleImage = async (
  sourceImg: HTMLImageElement,
  repeatX: number,
  repeatY: number,
  scaleWidth?: number,
  scaleHeight?: number,
): Promise<HTMLImageElement> => {
  const canvas = document.createElement('canvas');
  canvas.width = sourceImg.width * repeatX;
  canvas.height = sourceImg.height * repeatY;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not get canvas context');

  for (let x = 0; x < repeatX; x++) {
    for (let y = 0; y < repeatY; y++) {
      ctx.drawImage(sourceImg, x * sourceImg.width, y * sourceImg.height);
    }
  }

  if (!scaleWidth || !scaleHeight) {
    return ensureLoadedImage(canvas.toDataURL('image/png'));
  }

  const scaledCanvas = document.createElement('canvas');
  scaledCanvas.width = scaleWidth;
  scaledCanvas.height = scaleHeight;

  const scaledCtx = scaledCanvas.getContext('2d');
  if (!scaledCtx) throw new Error('Could not get scaled canvas context');

  scaledCtx.imageSmoothingEnabled = true;
  scaledCtx.imageSmoothingQuality = 'high';

  scaledCtx.drawImage(canvas, 0, 0, scaleWidth, scaleHeight);

  return ensureLoadedImage(scaledCanvas.toDataURL('image/png'));
};

export const ensureLoadedImage = (
  src: string,
  crossOrigin?: string,
): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    if (crossOrigin) {
      img.crossOrigin = crossOrigin;
    }
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
    img.src = src;
  });
};
